import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulSyncProductVariants,
    addSinglePrintfulSyncProductVariants,
    updateSinglePrintfulSyncProductVariants,
    getSinglePrintfulSyncProductVariants,
    getAllPrintfulSyncProductVariants,
    searchPrintfulSyncProductVariants,
    searchPrintfulSyncProductVariantsWithSearchCriteria,
    preparePrintfulSyncProductVariantsList
}

const collectionName = 'printful-sync-product-variants';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulSyncProductVariants = (printfulSyncProductVariants) => {
    return Promise.map(printfulSyncProductVariants, async printfulSyncProductVariants => {
        await addSinglePrintfulSyncProductVariants(printfulSyncProductVariants);
    });
}

const addSinglePrintfulSyncProductVariants = (printfulSyncProductVariants) => {
    printfulSyncProductVariants.createdAt = new Date();
    printfulSyncProductVariants.updatedAt = printfulSyncProductVariants.createdAt;
    return addDoc(collectionReference, printfulSyncProductVariants);
}

const updateSinglePrintfulSyncProductVariants = (printfulSyncProductVariants) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulSyncProductVariants.id);
    printfulSyncProductVariants.updatedAt = new Date();
    return setDoc(documentReference, printfulSyncProductVariants);
}

const getSinglePrintfulSyncProductVariants = async (printfulSyncProductVariantsId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulSyncProductVariantsId);
    const printfulSyncProductVariantsDoc = await getDoc(documentReference);
    return prepareSinglePrintfulSyncProductVariants(printfulSyncProductVariantsDoc);
}

const getAllPrintfulSyncProductVariants = async () => {
    let searchQuery = query(collectionReference);
    const printfulSyncProductVariantsResult = await getDocs(searchQuery);
    return preparePrintfulSyncProductVariantsList(printfulSyncProductVariantsResult);
}

const searchPrintfulSyncProductVariants = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const printfulSyncProductVariantsResult = await getDocs(searchQuery);
    return preparePrintfulSyncProductVariantsList(printfulSyncProductVariantsResult);
}

const searchPrintfulSyncProductVariantsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulSyncProductVariantsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
            searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
        }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulSyncProductVariantsResult = await getDocs(searchQuery);
    return preparePrintfulSyncProductVariantsList(printfulSyncProductVariantsResult);
}

const preparePrintfulSyncProductVariantsList = (printfulSyncProductVariantsResult) => {
    const printfulSyncProductVariantsList = [];

    _.forEach(printfulSyncProductVariantsResult.docs, printfulSyncProductVariantsDoc => {
        printfulSyncProductVariantsList.push(prepareSinglePrintfulSyncProductVariants(printfulSyncProductVariantsDoc));
    });

    return printfulSyncProductVariantsList;
}


const prepareSinglePrintfulSyncProductVariants = (printfulSyncProductVariantsDoc) => {
    const printfulSyncProductVariants = printfulSyncProductVariantsDoc.data();
    printfulSyncProductVariants.id = printfulSyncProductVariantsDoc.id;
    return printfulSyncProductVariants;
}
